import React, { useEffect, useState } from 'react';
import { Form, notification } from 'antd';
import { RootState, useAppDispatch } from '../../../app/store';
import { useSelector } from 'react-redux';
import LoadingComponent from '../../../components/Spin';
import AddUpdateReportsMapping from './component/AddUpdateReportsMapping';
import ReportsMapping from './ReportsMapping';
import { fetchReportsMinistriesMappingList, mapReportsMinistry, deleteIndicatorsReports } from './reportsMappingApi';
import { fetchMinistries, fetchReports } from '../../master/masterApi';
import { uniqueObjects } from '../../../utils/commonFunctions';
import { useTranslation } from 'react-i18next';

interface ReportsMappingContainerProps {

}

const ReportsMappingContainer: React.FC<ReportsMappingContainerProps> = (props) => {
    const [form] = Form.useForm();
    const [isAddUpdateMapping, setIsAddUpdateMapping] = useState<boolean>(false);
    const [selectedMinistryId, setSelectedMinistryId] = useState();
    const [selectedFilters, setSelectedFilters] = useState<number[]>([]);
    const [isAllSelected, setIsAllSelected] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const { reportsMinistries, isLoading } = useSelector((state: RootState) => state.reportsMinistryMapping);
    const { reports, ministries } = useSelector((state: RootState) => state.masterData);
    const { t } = useTranslation();

    useEffect(() => {
        dispatch(fetchReportsMinistriesMappingList());
    }, [dispatch, isAddUpdateMapping]);

    //Fetch reports master list if its not already loaded
    useEffect(() => {
        if (!(reports?.length)) {
            dispatch(fetchReports());
        }
    }, [dispatch, reports])

    //Handle click on add or edit icon event in ministry reports mapping list
    const handleAddEditReportsMapping = (value?: any) => {
        if (!(ministries?.length)) {
            dispatch(fetchMinistries());
        }
        setSelectedMinistryId(value);
        setIsAddUpdateMapping(true);
    };

    // Collect reports that are associated with ministries including their ID
    const associatedReports = Array.from(
        new Set(
            reportsMinistries.flatMap(ministry =>
                ministry.reports.map((report: any) => ({
                    id: report.id,
                    name: report.name
                }))
            )
        )
    );

    //Collect uniq reports from the associated reports
    const uniqAssociatedReports = uniqueObjects(associatedReports);

    //Handle indicator filter check box change event
    const onFilterChanged = (value: number[]) => {
        setSelectedFilters(value);
        setIsAllSelected(value?.length === uniqAssociatedReports?.length);
    }

    // Filter ministries based on selected filters
    const filteredReportsMinistries = reportsMinistries.filter(ministry =>
        selectedFilters.length === 0 ||
        ministry?.reports?.some((report: any) => selectedFilters.includes(report.id))
    );

    const onHandleReportsDelete = (ministryId: any) => {
        const finalObject = {
            nodeId: ministryId,
        };

        dispatch(deleteIndicatorsReports(finalObject))
            .unwrap()
            .then((response) => {

                form.resetFields();
                if (response?.status === 'success') {
                    notification.success({ message: t('success'), description: response?.message });
                    dispatch(fetchReportsMinistriesMappingList());
                }
                setIsAddUpdateMapping(false)
            });
    };
    return (
        <>
            {/* {isLoading ? <LoadingComponent size='default' /> : */}
            <>

                <ReportsMapping
                    ministries={filteredReportsMinistries}
                    handleAddEditReportsMapping={(value) => handleAddEditReportsMapping(value)}
                    associatedReports={uniqAssociatedReports}
                    filterOnChange={onFilterChanged}
                    filterSelectedReports={selectedFilters}
                    isAllSelected={isAllSelected}
                    handleDeleteReport={(ministryId) => onHandleReportsDelete(ministryId)} />

            </>
            {/* } */}
        </>
    );
};

export default ReportsMappingContainer;